<template>
  <base-modal
    size="lg"
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
  >
    <template #header>
      {{$t('buttons.sendMessage')}}
    </template>
    <template #body>
      <create :id-sender-type="idSenderType" :recipient="recipient"></create>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/excmmessage/Create'

export default {
  name: 'CreateNewMessageModal',
  components: {
    Create,
    BaseModal
  },
  props: ['idSenderType', 'recipient'],
  computed: {
    ...mapGetters({
      isVisible: 'excmmessage/createModal/getIsVisible',
      created: 'excmmessage/create/created'
    })
  },
  watch: {
    created (val) {
      if (val) this.toggleModal()
    }
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'excmmessage/create/reset'
    }),
    ...mapMutations({
      toggleModal: 'excmmessage/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
